import React from 'react';
import { LoopButton } from '@loophealth/loop-ui-web-library';
import { StyledBackButton } from './styles';
import { IMobileBackButtonProps } from './types';

const MobileBackButton: React.FC<IMobileBackButtonProps> = ({ onClick, hasModalTitle }) => (
    <StyledBackButton $hasModalTitle={hasModalTitle}>
        <LoopButton
            variant="text"
            onClick={onClick}
            size="large"
        >
            ‹ Back
        </LoopButton>
    </StyledBackButton>
);

export default MobileBackButton;
